<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="12" md="8">
            <v-text-field
              prepend-icon="chevron_left"
              @click:prepend="$router.push('/cards')"
              label="Search in cards"
              clearable
              v-model="searchString"
              append-icon="search"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-row class="d-flex justify-center align-center">
              <v-switch class="pr-2" label="Black" v-model="showBlack" color="black"></v-switch>
              <v-switch label="White" v-model="showWhite" color="blue-grey lighten-5"></v-switch>
            </v-row>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row v-if="cardPack">
          <v-col cols="6" md="3" v-for="card of displayCardsBlack" :key="card[0]">
            <v-card class="card black--card">
              <v-card-title>
                <CardText :cardtext="card[1].text" />
                <!-- {{card[1].text}} -->
              </v-card-title>
            </v-card>
          </v-col>
          <v-col cols="6" md="3" v-for="card of displayCardsWhite" :key="card[0]">
            <v-card class="card white--card">
              <v-card-title>
                <CardText :cardtext="card[1].text" />
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { packsref } from "../../firebase";
import CardText from "../../components/CardText";
export default {
  name: "PackOverview",
  data() {
    return {
      cardPack: null,
      searchString: "",
      blackArr: [],
      whiteArr: [],
      showBlack: true,
      showWhite: true
    };
  },
  computed: {
    displayCardsBlack: function() {
      if (!this.showBlack) return [];
      let search = this.searchString || "";
      return search.length > 0
        ? this.blackArr.filter(x =>
            x[1].text.toLowerCase().includes(this.searchString.toLowerCase())
          )
        : this.blackArr;
    },
    displayCardsWhite() {
      if (!this.showWhite) return [];
      let search = this.searchString || "";
      return search.length > 0
        ? this.whiteArr.filter(x =>
            x[1].text.toLowerCase().includes(this.searchString.toLowerCase())
          )
        : this.whiteArr;
    }
  },
  methods: {},
  watch: {
    "cardPack.black_cards": function(val) {
      this.blackArr = Object.entries(val);
    },
    "cardPack.white_cards": function(val) {
      this.whiteArr = Object.entries(val);
    }
  },
  firebase() {
    return {
      cardPack: packsref.child(this.$route.params.packId)
    };
  },
  components: {
    CardText
  }
};
</script>

<style>
.card {
  height: 30vh;
  min-height: 150px;
}

.card.black--card {
  background-color: black;
}

.card.black--card .v-card__title {
  color: white;
}

.card .v-card__title {
  word-break: break-word !important;
  font-size: 1rem;
  line-height: 1rem;
}

.card .v-card__actions {
  position: absolute;
  bottom: 0;
  right: 0;
}

.card.black--card::after {
  content: "";
  height: 30px;
  width: 40px;
  background: url("/images/logo.svg") no-repeat;
  position: absolute;
  background-size: 30px;
  margin: 8px;
  bottom: 0;
  left: 0;
  filter: invert(100%);
}
.card.white--card::after {
  content: "";
  height: 30px;
  width: 100px;
  background: url("/images/logo.svg") no-repeat;
  position: absolute;
  background-size: 30px;
  margin: 8px;
  bottom: 0;
  left: 0;
}
</style>